// A small, predictable matcher for the palette's commands. Higher is better;
// -1 means no match. Exact beats prefix beats word-start beats substring
// beats subsequence, so "dark" finds "Toggle dark mode" before "Dashboard".
export function score(query, text) {
  const q = String(query || '').toLowerCase().trim();
  const t = String(text || '').toLowerCase();
  if (!q) return 0;
  if (t === q) return 100;
  if (t.startsWith(q)) return 90;
  if (t.split(/[\s\-_/]+/).some((w) => w.startsWith(q))) return 80;
  if (t.includes(q)) return 60;
  let i = 0;
  for (const ch of t) {
    if (ch === q[i]) i += 1;
    if (i === q.length) break;
  }
  return i === q.length ? 30 : -1;
}

/** The best score across a command's label and keywords. */
export function scoreCommand(query, command) {
  const candidates = [command.label, ...(command.keywords || [])];
  return Math.max(...candidates.map((c) => score(query, c)));
}
